document
  .getElementById("ip-lookup-form")
  .addEventListener("submit", (event) => {
    event.preventDefault();
    const ip = document.getElementById("ip-lookup-input").value;
    if (ip) {
      window.location.href = `/${ip}`;
    }
  });
